// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3Gj_u","label":"Completed_label__1y2M8"};